import { MEETING_LINK_CONSULTING_QC_EN, MEETING_LINK_CONSULTING_QC_FR, MEETING_LINK_ROADMAP_FR, MEETING_LINK_ROADMAP_QC_EN, MEETING_LINK_ROADMAP_ROC_EN, MEETING_LINK_SDR_ROC_EN, MEETING_LINK_SDR_ROC_FR, MEETING_LINK_ZOOM_PLATFORM, } from '../links';
import { isNonProfitOrganization } from './check-company-icp';
import { showSmbButton } from './show-smb-button';
import { resolveSmbButton } from './smb-button';
export function resolveNavigation(selectedLocale, accessLevel, company, admin, handleCheckout) {
    const isEnglish = selectedLocale === 'en';
    const isFromQuebec = company.province === 'QC';
    const revenue = company.annual_revenue;
    const isCompanyNPO = isNonProfitOrganization(company.legal_structure || '');
    if (accessLevel === 'custom') {
        if (isEnglish) {
            return {
                title: 'Talk to my account manager',
                link: (admin === null || admin === void 0 ? void 0 : admin.meeting_link_en) || '',
            };
        }
        else {
            return {
                title: 'Parler à mon gestionnaire de compte',
                link: (admin === null || admin === void 0 ? void 0 : admin.meeting_link_fr) || '',
            };
        }
    }
    if (accessLevel === 'premium' || accessLevel === 'expert') {
        if (showSmbButton(selectedLocale, accessLevel, company)) {
            return resolveSmbButton(selectedLocale, company);
        }
        if (isEnglish) {
            return {
                title: 'Talk to an expert',
                link: MEETING_LINK_ZOOM_PLATFORM,
            };
        }
        else {
            return {
                title: 'Parler à un expert',
                link: MEETING_LINK_ZOOM_PLATFORM,
            };
        }
    }
    if (isEnglish) {
        if (isFromQuebec) {
            if (!isCompanyNPO && (revenue === '100m' || revenue === '100m+')) {
                return {
                    title: 'Talk to an expert',
                    link: MEETING_LINK_ROADMAP_QC_EN,
                };
            }
            if (revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: 'Talk to an expert',
                    link: MEETING_LINK_CONSULTING_QC_EN,
                };
            }
            else {
                return {
                    title: 'View our plans',
                    action: handleCheckout,
                };
            }
        }
        if (!isFromQuebec) {
            if (!isCompanyNPO && (revenue === '100m' || revenue === '100m+')) {
                return {
                    title: 'Talk to an expert',
                    link: MEETING_LINK_ROADMAP_ROC_EN,
                };
            }
            if (revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: 'Talk to an expert',
                    link: MEETING_LINK_SDR_ROC_EN,
                };
            }
            else {
                return {
                    title: 'View our plans',
                    action: handleCheckout,
                };
            }
        }
    }
    if (!isEnglish) {
        if (isFromQuebec) {
            if (!isCompanyNPO && (revenue === '100m' || revenue === '100m+')) {
                return {
                    title: 'Parler à un expert',
                    link: MEETING_LINK_ROADMAP_FR,
                };
            }
            if (revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: 'Parler à un expert',
                    link: MEETING_LINK_CONSULTING_QC_FR,
                };
            }
            else {
                return {
                    title: 'Voir nos plans',
                    action: handleCheckout,
                };
            }
        }
        if (!isFromQuebec) {
            if (!isCompanyNPO && (revenue === '100m' || revenue === '100m+')) {
                return {
                    title: 'Parler à un expert',
                    link: MEETING_LINK_ROADMAP_FR,
                };
            }
            if (revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: 'Parler à un expert',
                    link: MEETING_LINK_SDR_ROC_FR,
                };
            }
            else {
                return {
                    title: 'Voir nos plans',
                    action: handleCheckout,
                };
            }
        }
    }
    return {
        title: isEnglish ? 'See our plans' : 'Voir nos plans',
        action: handleCheckout,
    };
}
